export const SETUP_OPTION_SELF = 'SELF';
export const SETUP_OPTION_PROF = 'PROFESSIONAL';
export const INVALID_PHONE_MESSAGE = 'Please enter a valid 10 digit phone number.';
export const INVALID_EMAIL_MESSAGE = 'Please enter a valid email address';
